import { Chip, Stack, Typography } from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useTranslation } from "react-i18next";
import { AppButton } from "../form";
import type { CrossFilter } from "../../utils/crossFilter";
import { useAppCustomStyles } from "../../assets/theme/custom/hooks";

type Props = {
  filters: CrossFilter[];
  onRemove: (filter: CrossFilter) => void;
  onClearAll: () => void;
};

export default function DashboardCrossFilterBar({ filters, onRemove, onClearAll }: Props) {
  const { t } = useTranslation();
  const custom = useAppCustomStyles();
  if (!filters.length) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      flexWrap="wrap"
      gap={1}
      sx={custom.components.dashboardCrossFilterBar.root}
      className="no-print"
    >
      <Typography variant="caption" color="text.secondary" sx={custom.components.dashboardCrossFilterBar.label}>
        {t("crossFilter.active")}
      </Typography>
      {filters.map((filter) => (
        <Chip
          key={`${filter.field}-${filter.value}`}
          size="small"
          color="primary"
          variant="outlined"
          label={`${filter.field}: ${filter.label || filter.value}`}
          onDelete={() => onRemove(filter)}
          deleteIcon={<CloseOutlinedIcon />}
        />
      ))}
      <AppButton variant="outlined" size="small" onClick={onClearAll}>
        {t("crossFilter.clearAll")}
      </AppButton>
    </Stack>
  );
}
